export default {
  "common.save": "सहेजें",
  "common.cancel": "रद्द करें",
  "common.delete": "हटाएं",
  "common.edit": "संपादित करें",
  "common.add": "जोड़ें",
  "common.back": "वापस",
  "common.loading": "लोड हो रहा है...",
  "common.error": "कुछ गलत हुआ",
  "common.success": "सफल",
  "common.confirm": "पुष्टि करें",
  "common.search": "खोजें",
  "common.filter": "फ़िल्टर",
  "common.all": "सभी",
  "common.comingSoon": "जल्द आ रहा है",
  "common.noResults": "कोई परिणाम नहीं",
  "common.retry": "पुनः प्रयास करें",

  "auth.login": "लॉग इन करें",
  "auth.signup": "साइन अप करें",
  "auth.logout": "लॉग आउट",
  "auth.email": "ईमेल",
  "auth.password": "पासवर्ड",
  "auth.name": "पूरा नाम",
  "auth.confirmPassword": "पासवर्ड की पुष्टि करें",
  "auth.forgotPassword": "पासवर्ड भूल गए?",
  "auth.noAccount": "खाता नहीं है?",
  "auth.haveAccount": "पहले से खाता है?",
  "auth.agreeTerms": "मैं सेवा की शर्तें और गोपनीयता नीति से सहमत हूं",

  "nav.home": "होम",
  "nav.payments": "भुगतान",
  "nav.add": "जोड़ें",
  "nav.analytics": "विश्लेषण",
  "nav.profile": "प्रोफ़ाइल",
  "nav.allPayments": "सभी भुगतान",
  "nav.addPayment": "भुगतान जोड़ें",
  "nav.subscriptions": "सदस्यताएं",
  "nav.calendar": "कैलेंडर",
  "nav.documents": "दस्तावेज़",
  "nav.settings": "सेटिंग्स",
  "nav.personalInfo": "व्यक्तिगत जानकारी",
  "nav.changePassword": "पासवर्ड बदलें",
  "nav.twoFactor": "दो-कारक प्रमाणीकरण",
  "nav.devices": "डिवाइस",
  "nav.reminders": "अनुस्मारक",
  "nav.editPayment": "भुगतान संपादित करें",
  "nav.paymentDetail": "भुगतान विवरण",

  "dashboard.title": "डैशबोर्ड",
  "dashboard.greeting": "सुप्रभात",
  "dashboard.totalDue": "कुल देय",
  "dashboard.thisMonth": "इस महीने",
  "dashboard.upcomingPayments": "आगामी भुगतान",
  "dashboard.quickStats": "त्वरित आँकड़े",
  "dashboard.noUpcoming": "कोई आगामी भुगतान नहीं",
  "dashboard.addFirst": "शुरू करने के लिए पहला भुगतान जोड़ें",
  "dashboard.budgetUsed": "बजट उपयोग",

  "payments.title": "भुगतान",
  "payments.add": "भुगतान जोड़ें",
  "payments.edit": "भुगतान संपादित करें",
  "payments.detail": "भुगतान विवरण",
  "payments.amount": "राशि",
  "payments.dueDate": "देय तिथि",
  "payments.category": "श्रेणी",
  "payments.frequency": "आवृत्ति",
  "payments.notes": "नोट्स",
  "payments.status.paid": "भुगतान किया",
  "payments.status.pending": "लंबित",
  "payments.status.overdue": "अतिदेय",
  "payments.markAsPaid": "भुगतान के रूप में चिह्नित करें",
  "payments.deleteConfirm": "यह भुगतान हटाएं?",
  "payments.frequency.once": "एक बार",
  "payments.frequency.weekly": "साप्ताहिक",
  "payments.frequency.monthly": "मासिक",
  "payments.frequency.yearly": "वार्षिक",
  "payments.noPayments": "अभी तक कोई भुगतान नहीं",

  "subscriptions.title": "सदस्यताएं",
  "subscriptions.add": "सदस्यता जोड़ें",
  "subscriptions.monthly": "मासिक व्यय",
  "subscriptions.active": "सक्रिय",
  "subscriptions.paused": "रुका हुआ",
  "subscriptions.overdue": "अतिदेय",
  "subscriptions.nextBilling": "अगली बिलिंग",
  "subscriptions.billingCycle": "बिलिंग चक्र",

  "analytics.title": "विश्लेषण",
  "analytics.spendingByCategory": "श्रेणी के अनुसार खर्च",
  "analytics.monthlyTrend": "मासिक प्रवृत्ति",
  "analytics.totalSpent": "कुल खर्च",
  "analytics.paidThisMonth": "इस महीने भुगतान",
  "analytics.pending": "लंबित",
  "analytics.noData": "इस अवधि के लिए कोई डेटा नहीं",

  "calendar.title": "कैलेंडर",
  "calendar.noPaymentsToday": "इस तारीख पर कोई भुगतान नहीं",
  "calendar.connectGoogle": "Google Calendar से जोड़ें",
  "calendar.export": "कैलेंडर निर्यात करें (.ics)",
  "calendar.openGoogle": "Google Calendar खोलें",
  "calendar.sync": "कैलेंडर सिंक",

  "documents.title": "दस्तावेज़",
  "documents.upload": "दस्तावेज़ अपलोड करें",
  "documents.noDocuments": "कोई दस्तावेज़ अपलोड नहीं",
  "documents.maxSize": "अधिकतम 10MB — PDF, JPEG, PNG",

  "profile.title": "प्रोफ़ाइल",
  "profile.settings": "सेटिंग्स",
  "profile.reminders": "अनुस्मारक",
  "profile.personalInfo": "व्यक्तिगत जानकारी",
  "profile.changePassword": "पासवर्ड बदलें",
  "profile.twoFactor": "दो-कारक प्रमाणीकरण",
  "profile.devices": "डिवाइस",
  "profile.language": "भाषा",
  "profile.currency": "मुद्रा",
  "profile.deleteAccount": "खाता हटाएं",
  "profile.plan.free": "मुफ़्त योजना",
  "profile.plan.pro": "Pro योजना",
  "profile.upgradeToPro": "Pro में अपग्रेड करें",
  "profile.connectedDevices": "जुड़े हुए डिवाइस",
  "profile.pendingTill": "तारीख तक लंबित",

  "reminders.title": "अनुस्मारक प्राथमिकताएं",
  "reminders.daysBefore": "पहले याद दिलाएं",
  "reminders.email": "ईमेल सूचनाएं",
  "reminders.push": "पुश सूचनाएं",
  "reminders.sms": "SMS सूचनाएं",

  "upgrade.title": "Pro में अपग्रेड करें",
  "upgrade.subtitle": "सभी सुविधाएं अनलॉक करें",
  "upgrade.perMonth": "/माह",
  "upgrade.upgrade": "अभी अपग्रेड करें",

  "notifications.title": "सूचनाएं",
  "notifications.none": "कोई नई सूचना नहीं",
  "notifications.viewAll": "सभी भुगतान देखें",
  "notifications.overdue": "अतिदेय है",
  "notifications.dueToday": "आज देय है",
  "notifications.dueSoon": "में देय है",
  "notifications.days": "दिन",

  "error.required": "यह फ़ील्ड आवश्यक है",
  "error.invalidEmail": "अमान्य ईमेल पता",
  "error.passwordTooShort": "पासवर्ड कम से कम 6 अक्षर का होना चाहिए",
  "error.passwordMismatch": "पासवर्ड मेल नहीं खाते",
  "error.networkError": "नेटवर्क त्रुटि। अपना कनेक्शन जांचें।",
  "error.unauthorized": "सत्र समाप्त हो गया। फिर से लॉग इन करें।",
  "error.notFound": "पृष्ठ नहीं मिला",

  "settings.language": "भाषा",
  "settings.selectLanguage": "भाषा चुनें",
  "settings.selectCurrency": "मुद्रा चुनें",
};
